import React from "react";

export default function UI5MenuSeparator() {

    return (
        <div className="separator-h-small m-t-15 m-b-15" />
    )

}
